<template>
  <el-dialog
    title="警告"
    width="30%"
    :before-close="handleClose"
    :visible.sync="warnVisible"
    :close-on-click-modal="false"
  >
    <div class="content">{{ message || defaultMessage }}</div>
    <div class="num">当前违规次数：<span class="red">{{ num }}次</span></div>
    <span slot="footer" class="dialog-footer">
      <el-button class="cancel" @click="handleClose">取消</el-button>
      <el-button class="sure" type="primary" @click="confirm">交卷</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    warnVisible: {
      type: Boolean,
      default: false
    },
    num: {
      type: Number,
      default: 0
    },
    message: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      defaultMessage: '考试期间严禁各种作弊行为(切屏、使用其他各类软件搜索答案等)，系统将对所有违规行为进行自动监测并记录留档，未来可能会产生不可预知的负面影响，继续违规会直接交卷按作弊处理，请严格遵守考场秩序，诚信应考。'
    }
  },
  methods: {
    handleClose() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    }
  }
}
</script>
    <style lang="scss" scoped>
  .content{
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #606060;
      line-height: 22px;
  }
  .num{
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #606060;
      line-height: 22px;
      margin-top: 30px;
      .red{
        color: #DD594A;
      }
  }
    </style>

